import styled from 'styled-components';
import { themeOptions } from 'styles/theme';

export const StyledTextField = styled.div`
  position: relative;

  .MuiOutlinedInput-root {
    height: 40px;
    width: ${(props) => (props.width ? props.width : null)};
    background-color: ${themeOptions.palette.white.main};
    border: 1px solid ${themeOptions.palette.gray.border};
    border-radius: 6px;

    &:hover {
      box-shadow: 0px 0px 0px 3px var(--color-off-white);
      .MuiOutlinedInput-notchedOutline {
        border: 1px solid #dadada;
      }
    }
    &:active {
      border-color: ${themeOptions.palette.green.main};
    }

    .MuiOutlinedInput-input {
      padding: 0 10px;
      width: 100%;
      border-radius: 6px;
      outline: none;
      appearance: none;
      background-color: ${themeOptions.palette.white.main};

      &:disabled {
        background-color: ${themeOptions.palette.gray.light};
      }
    }
  }

  /* required 경우, disabled style */
  .MuiOutlinedInput-root.Mui-disabled {
    background-color: ${themeOptions.palette.gray.light};
  }
`;
